module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_9.0d88d211.pdf";